import { getTimeOffTypeLabel } from './timeOffTypes'

interface CurrentRequestAllocation {
  hours: number
  toTypeCd: string
}

interface CurrentRequestDate {
  toReqId: string
  toReqDtlId: number
  durationFlag?: string | null
  day: string
  startTime?: string | null
  endTime?: string | null
  timeOffAllocations: CurrentRequestAllocation[]
}

interface TooltipEntry {
  durationLabel: string
  date: string
  allocations: Array<{
    typeLabel: string
    hours: number
  }>
  totalHours: number
  startTime?: string
  endTime?: string
  individualRequests?: Array<{
    allocations: Array<{
      typeLabel: string
      hours: number
    }>
    totalHours: number
    startTime?: string
    endTime?: string
  }>
}

export const buildCurrentRequestTooltipDetails = (
  requestedDates: Record<string, CurrentRequestDate> = {}
): Record<string, TooltipEntry> => {
  const result: Record<string, TooltipEntry> = {}
  Object.entries(requestedDates).forEach(([dateKey, requestDate]) => {
    const [year, month, day] = dateKey.split('-')
    const allocations =
      requestDate.timeOffAllocations?.map(allocation => ({
        typeLabel: getTimeOffTypeLabel(allocation.toTypeCd),
        hours: Number(allocation.hours || 0),
      })) ?? []
    const totalHours = allocations.reduce(
      (sum, item) => sum + item.hours,
      0
    )
    /**
     * IMPORTANT:
     * API sends:
     * F = Full Day
     * P = Partial Day
     */
    const isPartialDay =
      requestDate.durationFlag === 'P'


    result[dateKey] = {
      date: `${month}/${day}/${year}`,
      durationLabel: isPartialDay
        ? 'Partial Day'
        : 'Full Day',
      allocations,
      totalHours,
      individualRequests: [
        {
          allocations,
          totalHours,
          ...(requestDate.startTime
            ? {
                startTime: requestDate.startTime
              }
            : {}),
          ...(requestDate.endTime
            ? {
                endTime: requestDate.endTime
              }
            : {})
        }
      ],
      ...(requestDate.startTime
        ? {
            startTime: requestDate.startTime
          }
        : {}),
      ...(requestDate.endTime
        ? {
            endTime: requestDate.endTime
          }
        : {})
    }

  })


  return result
}